export default "__VITE_ASSET__CDQGNxGz__"